import Global from '../../js/constant.js'

const circleEdit = {
  state: {
    circleEditCircleId: null,
    circleEditTabId: Global.settings_tab_id.circle,
    circleEditBasic: null,
    circleEditMembers: null,
    circleEditInviteMembers: null,
    circleEditRequestMembers: null,
    circleEditGroups: null,
    circleEditHashtags: null,
    circleEditRsses: null,
  },
  getters: {
    circleEditCircleId(state) { return state.circleEditCircleId },
    circleEditTabId(state) { return state.circleEditTabId },
    circleEditBasic(state) { return state.circleEditBasic },
    circleEditMembers(state) { return state.circleEditMembers },
    circleEditInviteMembers(state) { return state.circleEditInviteMembers },
    circleEditRequestMembers(state) { return state.circleEditRequestMembers },
    circleEditGroups(state) { return state.circleEditGroups },
    circleEditHashtags(state) { return state.circleEditHashtags },
    circleEditRsses(state) { return state.circleEditRsses },
  },
  mutations: {
    setCircleEditCircleId (state, value) {
      state.circleEditCircleId = value
    },
    setCircleEditTabId (state, value) {
      if (value == null) {
        state.circleEditTabId = Global.settings_tab_id.circle
        return
      }
      state.circleEditTabId = value
    },
    setCircleEditBasic (state, value) {
      state.circleEditBasic = value
    },
    setCircleEditMembers (state, value) {
      state.circleEditMembers = value
    },
    concatCircleEditMembers (state, value) {
      if (state.circleEditMembers == null) {
        state.circleEditMembers = value
        return
      }
      state.circleEditMembers = state.circleEditMembers.concat(value)
    },
    setCircleEditInviteMembers (state, value) {
      state.circleEditInviteMembers = value
    },
    setCircleEditRequestMembers (state, value) {
      state.circleEditRequestMembers = value
    },
    setCircleEditGroups (state, value) {
      state.circleEditGroups = value
    },
    setCircleEditHashtags (state, value) {
      state.circleEditHashtags = value
    },
    setCircleEditRsses (state, value) {
      state.circleEditRsses = value
    },
    initStateCircleEdit (state) {
      state.circleEditCircleId = null
      state.circleEditTabId = Global.settings_tab_id.circle
      state.circleEditBasic = null
      state.circleEditMembers = null
      state.circleEditInviteMembers = null
      state.circleEditRequestMembers = null
      state.circleEditGroups = null
      state.circleEditHashtags = null
      state.circleEditRsses = null
    }
  },
  actions: {},
  modules: {}
}
export default circleEdit